export default __webpack_public_path__ + "maps-examples-custom-callout-thumbnail-480-6d32eca9deed706c344452f7c684e911.webp";